import { Carousel, Typography as T } from 'antd'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import React from 'react'
import './index.scss'


interface Props {
  locale: string
}

const CarouselHeader = (props: Props) => {
  const { allPrismicHome } = useStaticQuery(query)
  const edge = allPrismicHome.edges.find((item: any) => item.node.lang === props.locale)

  if (!edge) {
    return null
  }

  return (
    <div className="sg-carousel-header">
      <Carousel
        autoplay={true}
        slidesToShow={1}
        slidesToScroll={1}
        draggable={true}
        arrows={false}
        speed={10000}
      // centerMode={true}
      // centerPadding="0"
      // cssEase="ease"
      // slideOffset={false}
      // easing="linear"
      >
        {edge.node.data.body.map((item: any) => (
          <div key={item.id} className="sg-content-silde">
            <div className="text-banner">
              <div className="content">
                <h3 className="title">
                  <span>{item.primary.title_of_banner.text}</span>
                </h3>
                <span className="sub">{item.primary.button_label.text}</span>
                <T.Paragraph ellipsis={{ rows: 5 }} className="des">
                  {item.primary.description.text}
                </T.Paragraph>
              </div>
            </div>
            <div className="img">
              <Img style={{ zIndex: -10 }} fluid={item.primary.image_banner.localFile.childImageSharp.fluid} />
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  )
}

const query = graphql`
  query BannerQuery {
    allPrismicHome {
      edges {
        node {
          lang
          data {
            body {
              ... on PrismicHomeBodyBannerWithCaption {
                id
                primary {
                  image_banner {
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 958) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                  title_of_banner {
                    text
                  }
                  description {
                    text
                  }
                  button_label {
                    text
                  }
                  button_link {
                    url
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

export default CarouselHeader
